import React, { useState } from 'react';
import BILHoldersAccounts from './BILHoldersAccounts';
import BILHoldersSelectionItem from './BILHoldersSelectionItem';

import './BILHolders.less';

const BILHoldersSelectionList = ({BILHoldersDto, confirmationButtonID, radioInputID}) => {

   const [isExpanded, expand] = useState(false);
   //const expandItem = () => expand(!isExpanded);

   return (
      <div className="BILHolders-container" name={BILHoldersDto.ownershipType}>

         <BILHoldersSelectionItem
            ownershipType={BILHoldersDto.ownershipType}
            holderNames={BILHoldersDto.holderNames}
            isExpanded={isExpanded}
            onClick={(e) => {onClick(e, confirmationButtonID, radioInputID) }}
         />

         {isExpanded ?
            <BILHoldersAccounts
               accounts={BILHoldersDto.accounts}
               confirmationButtonID={confirmationButtonID}
               radioInputID={radioInputID}
            />
            : null}
      </div>
      )

      function onClick (evt, confirmationButtonID, radioInputID) {
         var currentTargetElement = evt.currentTarget
      
         var BILConfirmationButton = document.getElementById(confirmationButtonID)
         var BILRadioButton = document.querySelector('input[name='+ radioInputID +']:checked')
      
         if (BILRadioButton !== null) {
            while (BILRadioButton && BILRadioButton.querySelector('.BILHolders-selection-item') === null) {
               BILRadioButton = BILRadioButton.parentElement;
            }
            if (currentTargetElement === BILRadioButton.querySelector('.BILHolders-selection-item')) {
               BILConfirmationButton.style.pointerEvents = 'none'
               BILConfirmationButton.style.opacity = '0.25'
            }
         }
         expand(!isExpanded)
      }
}

export default BILHoldersSelectionList
